import { render, staticRenderFns } from "./CatalogMultiselectDropdown.vue?vue&type=template&id=705d985e&scoped=true"
import script from "./CatalogMultiselectDropdown.vue?vue&type=script&lang=js"
export * from "./CatalogMultiselectDropdown.vue?vue&type=script&lang=js"
import style0 from "./CatalogMultiselectDropdown.vue?vue&type=style&index=0&id=705d985e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705d985e",
  null
  
)

export default component.exports